import { CDN2 } from '@/helpers/api';
import { Image } from 'antd';
import React from 'react';

export default function CreatorsTable() {
  return (
    <div>
      <table className="table-auto w-full border border-gray-300 text-sm hidden md:block">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-4 py-2">New Monthly Reservations</th>
            <th className="border px-4 py-2">
              Flat Rate Payment
              <br />
              ($5 Per Reservation)
            </th>
            <th className="border px-4 py-2">
              Net Sales based national average booking total
              <br />
              (Excludes Taxes and Fees)
            </th>
            <th className="border px-4 py-2">5% of Net Sales Payment</th>
            <th className="border px-4 py-2">
              Your Estimated Monthly Earnings
              <br />
              (Flat Rate Payment + 5% Net Sales Payment)
            </th>
            <th className="border px-4 py-2">
              Your Estimated Yearly Earnings
            </th>
          </tr>
        </thead>
        <tbody>
          {[
            [1, '$5.00', '$57.00', '$2.85', '$7.85', '$94.20'],
            [5, '$25.00', '$285.00', '$14.25', '$39.25', '$471.00'],
            [10, '$50.00', '$570.00', '$28.50', '$78.50', '$942.00'],
            [15, '$75.00', '$855.00', '$42.75', '$117.75', '$1,413.00'],
            [20, '$100.00', '$1,140.00', '$57.00', '$157.00', '$1,884.00'],
            [50, '$250.00', '$2,850.00', '$142.50', '$392.50', '$4,710.00'],
            [
              100,
              '$500.00',
              '$5,700.00',
              '$285.00',
              '$785.00',
              '$9,420.00',
            ],
            [
              200,
              '$1,000.00',
              '$11,400.00',
              '$570.00',
              '$1,570.00',
              '$18,840.00',
            ],
            [
              300,
              '$1,500.00',
              '$17,100.00',
              '$855.00',
              '$2,355.00',
              '$28,260.00',
            ],
            [
              500,
              '$2,500.00',
              '$28,500.00',
              '$1,425.00',
              '$3,925.00',
              '$47,100.00',
            ],
            [
              1000,
              '$5,000.00',
              '$57,000.00',
              '$2,850.00',
              '$7,850.00',
              '$94,200.00',
            ],
            [
              100000,
              '$500,000.00',
              '$5,700,000.00',
              '$285,000.00',
              '$785,000.00',
              '$9,420,000.00',
            ],
          ].map(([res, flat, sales, commission, monthly, yearly]) => (
            <tr key={monthly}>
              <td className="border px-4 py-1 text-center text-secondary">
                {res}
              </td>
              <td className="border px-4 py-1 text-center text-secondary">
                {flat}
              </td>
              <td className="border px-4 py-1 text-center text-secondary">
                {sales}
              </td>
              <td className="border px-4 py-1 text-center text-secondary">
                {commission}
              </td>
              <td className="border px-4 py-1 text-center font-medium bg-[#069B27]/10">
                {monthly}
              </td>
              <td className="border px-4 py-1 text-center font-medium bg-[#069B27]/10">
                {yearly}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="md:hidden mt-2">
        <Image
          src={CDN2() + '/staticmyapp/partnerus/creatorsTable.png'}
          alt="Earnings Structure Reminder"
          className="w-full border rounded-lg h-52"
          preview
        />
      </div>
    </div>

  );
}
